import { ApolloError } from "@apollo/client";
import FullLoading from "../FullLoading";

export default function PageLayout({
  title,
  subtitle,
  children,
  actions,
  loading,
  error,
  dataTestId,
}: {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  loading?: boolean;
  error?: ApolloError;
  dataTestId?: string;
}) {
  return (
    <div className="flex flex-col gap-4" data-testid={dataTestId}>
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-primary">{title}</h1>
        {actions ? actions : null}
      </div>

      {subtitle ? (
        <div className="text-sm text-secondary">{subtitle}</div>
      ) : null}

      {loading ? (
        <FullLoading />
      ) : error ? (
        <div className="text-secondary text-sm">
          Une erreur est survenue lors de la récupération des données. Veuillez
          réessayer plus tard.
        </div>
      ) : (
        children
      )}
    </div>
  );
}
